import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';

import styles from './titled-modal.css';

const TitledModalComponent = props => (
    <Modal
        isOpen
        className={classNames(styles.modalContent, props.className)}
        contentLabel={props.contentLabel}
        overlayClassName={props.overlayClassName}
        onRequestClose={props.onRequestClose}
    >
        <Box
            className={styles.body}
        >
            <div
                className={classNames(
                    styles.header,
                    styles.headerItem,
                    styles.headerItemTitle
                )}
            >
                {props.headerImage ? (
                    <img
                        className={styles.headerImage}
                        src={props.headerImage}
                    />
                ) : null}
                {props.contentLabel}
            </div>
            {props.children}
        </Box>
    </Modal>
);

TitledModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    contentLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    headerImage: PropTypes.string,
    onRequestClose: PropTypes.func
};

export default TitledModalComponent;
